import { useRef, useState } from "react";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { IconButton, Link } from "@mui/material";

const HELP_MENU_LINKS = [
  {
    label: "Visit our Help Center",
    href: "https://proscore.atlassian.net/servicedesk/customer/portal/8",
    target: "_blank",
    rel: "noopener noreferrer"
  },
  {
    label: "Email us your question",
    href: "mailto:support@proscore.ai"
  },
  {
    label: "Urgent after/hours email",
    href: "mailto:urgent@proscore.ai"
  }
];

export default function HelpMenu() {
  const [open, setOpen] = useState(false);
  const hoverTimeout = useRef();

  const handleMouseEnter = () => {
    clearTimeout(hoverTimeout.current);
    setOpen(true);
  };

  const handleMouseLeave = () => {
    hoverTimeout.current = setTimeout(() => setOpen(false), 100);
  };

  return (
    <div style={{ position: "relative", display: "flex", alignItems: "center" }} onMouseEnter={handleMouseEnter}onMouseLeave={handleMouseLeave}>

      <IconButton aria-label="Help and Support" tabIndex={0} sx={{color: "inherit", transition: "background 0.2s"}}>
        <HelpOutlineIcon sx={{ fontSize: 26, color: "rgba(0,0,0,0.54)" }} />
      </IconButton>

      <div role="menu" aria-label="Help links" tabIndex={-1} style={{position: "absolute", top: 38, right: 0, minWidth: 220, zIndex: 1400, background: "#fff", borderRadius: 10, boxShadow: "0 4px 24px rgba(0,0,0,0.14)", padding: "10px 0", opacity: open ? 1 : 0, pointerEvents: open ? "auto" : "none", transform: open ? "translateY(0)" : "translateY(-8px)", transition: "opacity 120ms cubic-bezier(.23,1.03,.77,.95), transform 180ms cubic-bezier(.23,1.03,.77,.95)", display: "flex", flexDirection: "column"}}>

        {HELP_MENU_LINKS.map(link => (
          <Link key={link.label} href={link.href} target={link.target} rel={link.rel} underline="none" sx={{px: 2, py: 1.2, color: "#2d3a4e", fontWeight: 500, borderRadius: 1.5, fontSize: ".85rem", "&:hover, &:focus": {background: "#f3f5fa", color: "#0052CC", textDecoration: "none"}}}>
            {link.label}
          </Link>
        ))}

      </div>
    </div>
  );
}
